import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AdminAppbar from "../Admin/AdminAppbar";
import AdminSidebar from "../Admin/AdminSidebar";

const DESKTOP_BREAKPOINT = 992;

const AdminDashboardShell = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < DESKTOP_BREAKPOINT : false
  );

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < DESKTOP_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarMobileOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebarExpanded = () => setSidebarExpanded((value) => !value);
  const toggleMobileSidebar = () => setSidebarMobileOpen((value) => !value);
  const closeMobileSidebar = () => setSidebarMobileOpen(false);

  const handleNavClick = () => {
    if (isMobile) {
      setSidebarMobileOpen(false);
    }
  };

  return (
    <div
      className={`user-dashboard-layout admin-dashboard-layout ${
        sidebarExpanded ? "sidebar-expanded" : "sidebar-collapsed"
      } ${sidebarMobileOpen ? "sidebar-mobile-open" : ""}`}
    >
      <AdminAppbar handleDrawerOpen={toggleMobileSidebar} isMobile={isMobile} />
      {sidebarMobileOpen && (
        <button
          type="button"
          className="sidebar-overlay"
          aria-label="Close menu"
          onClick={closeMobileSidebar}
        />
      )}
      <AdminSidebar
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? sidebarMobileOpen : true}
        collapsed={!sidebarExpanded}
        onClose={closeMobileSidebar}
        onNavClick={handleNavClick}
        onToggleExpanded={toggleSidebarExpanded}
      />
      <main className="user-dashboard-main admin-dashboard-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminDashboardShell;
